import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 * 第一列是fixed布局的table
 */
@Component({
})
export default class FixedTable extends Vue {
  @Prop()
  public title: IFixedTableTitle[];
  @Prop()
  public tableData: any[];
  @Prop({ default: false })
  public isOp: boolean;
  @Prop()
  public dataKey: string;

  public activeIndex = '';
  public isTouchTitle = false;
  public scrollLeft = 0;

  public get commonTitle() {
    return this.title.slice(1);
  }
  public mounted() {
    // console.log(this.tableData);
  }

  public handleScrollContent() {
    // for (const i of this.tableData) {
      // console.log(i.orderId)
    // }
    if (!this.isTouchTitle) {
      // tslint:disable-next-line:max-line-length
      // @ts-ignore
      this.$refs.scrollTit.scrollLeft = this.$refs.scrollContent.scrollLeft;
      // tslint:disable-next-line:max-line-length
      // @ts-ignore
      this.scrollLeft = this.$refs.scrollTit.scrollLeft;
    }
  }
  public handleScrollTitle() {
    if (this.isTouchTitle) {
      // tslint:disable-next-line:max-line-length
      // @ts-ignore
      this.$refs.scrollContent.scrollLeft = this.$refs.scrollTit.scrollLeft;
      // tslint:disable-next-line:max-line-length
      // @ts-ignore
      this.scrollLeft = this.$refs.scrollTit.scrollLeft;
    }
  }
  public handleTouchContent(e) {
    this.isTouchTitle = false;
    e.stopPropagation();
  }
  public handleTouchTitle(e) {
    this.isTouchTitle = true;
  }

  public handleActive(item, index) {
    if (this.activeIndex === item[this.dataKey]) {
      this.activeIndex = '';
    } else if (this.isOp) {
      this.activeIndex = item[this.dataKey];
    }

  }
  public isActive(key) {
    if (!this.isOp) {
      return false;
    }
    return this.activeIndex === key;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/FixedTable/FixedTable.ts